import { NydusRecipient } from './nydus-recipient.type';
import { OrderItem, OrderItemStatus } from './order-item.type';

export enum OrderStatus {
  Pending = 'pending',
  ProcessingCheckout = 'processing_checkout',
  FailedCheckout = 'failed_checkout',
  Fulfilling = 'fulfilling',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Refunded = 'refunded',
}

export type OrderIndexParamsStatus =
  | 'completed'
  | 'processing'
  | 'cancelled'
  | 'failed'
  | '';

const orderIndexParamsTypes = [
  'giftCard',
  'merchandise',
  'pointsTransfer',
  'cashRedemption',
  'retail',
  '',
] as const;

export type OrderIndexParamsItemType = typeof orderIndexParamsTypes[number];

export enum OrderRedemptionType {
  Auto = 'manage-auto-redemptions',
  Past = 'past-redemptions',
}

export interface OrderFilterParams {
  status: string; // String as is "completed,pending,failed"
  orderItemType: string; // String as is "giftCard,pointsTransfer,cashRedemption"
}

// TODO: Standardize the `OrderManageQueryParams` and `OrderIndexParams` types.
// OrderManageQueryParams - URL params in this specific view.
// OrderIndexParams - Params that the OrderApiService would use when sending over to NN.
// Distinction is due to - view should know its QueryParams and know about the existence of the URL.
// Facade, ApiService should not know about URL-specific attributes.
export interface OrderManageQueryParams {
  sort: '-created_at' | 'created_at';
  status: string; // query string composed of joined OrderIndexParamsStatus
  orderItemType: string; // query string composed of joined OrderIndexParamsItemType
}

export interface OrderIndexParams {
  filter: {
    status: OrderIndexParamsStatus[];
    orderItemType: OrderIndexParamsItemType[];
  };
  sort: '-created_at' | 'created_at';
}

export interface OrderStatusOption {
  name: string;
  value: OrderIndexParamsStatus;
}

export interface OrderItemTypeOption {
  name: string;
  value: OrderIndexParamsItemType;
}

export interface OrderSortOption {
  name: string;
  value: OrderIndexParams['sort'];
}

export interface OrderRedemptionTabsOption {
  name: string;
  value: OrderRedemptionType;
}

export interface Order {
  id: string;
  type: 'order';
  userId: string;
  status: OrderStatus;
  fulfillmentStatus: OrderItemStatus;
  stripePaymentIntentClientSecret: string | null;
  cashPaid: number;
  cashAmount: number;
  pointsAmount: number;
  pointsPaid: number;
  data: {
    recipient?: NydusRecipient;
  };
  createdAt: string;
  updatedAt: string;
  orderItems: OrderItem[];
}
